module.exports = __webpack_public_path__ + "img/avatar1.91a6302a.png";